import React, { useEffect, useState } from 'react';
import { collection, getDocs, deleteDoc, doc } from 'firebase/firestore';
import { ref, deleteObject } from 'firebase/storage';
import { firestore, storage } from '../../firebase-config'; // Update with your config path
import "../../styles/manageplacement.css";
const ManagePlacement = () => {
  const [placements, setPlacements] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch all placements
  useEffect(() => {
    const fetchPlacements = async () => {
      try {
        const placementsCollection = collection(firestore, 'placements');
        const placementsSnapshot = await getDocs(placementsCollection);
        const placementsList = placementsSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setPlacements(placementsList);
      } catch (error) {
        console.error("Error fetching placements: ", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPlacements();
  }, []);

  // Delete placement function
  const handleDelete = async (placement) => {
    try {
      // 1. First delete the image from Firebase Storage if it exists
      if (placement.imageUrl) {
        // Extract the path from the full URL
        const imageUrl = placement.imageUrl;
        // Get the file path by extracting it from the URL
        const storageRef = ref(storage, imageUrl);
        await deleteObject(storageRef).catch(err => {
          console.log("Image might not exist or error deleting image:", err);
        });
      }

      // 2. Then delete the document from Firestore
      await deleteDoc(doc(firestore, 'placements', placement.id));
      
      // 3. Update the UI by removing the deleted placement
      setPlacements(placements.filter(p => p.id !== placement.id));
      
      alert("Placement deleted successfully!");
    } catch (error) {
      console.error("Error deleting placement: ", error);
      alert("Failed to delete placement. Check console for details.");
    }
  };

  if (loading) {
    return <div>Loading placements...</div>;
  }

  return (
    <div className="placements-container1">
      <h2>All Placements</h2>
      {placements.length === 0 ? (
        <p>No placements found</p>
      ) : (
        <div className="placements-grid1">
          {placements.map(placement => (
            <div key={placement.id} className="placement-card1">
              {placement.imageUrl && (
                <img 
                  src={placement.imageUrl} 
                  alt={`${placement.studentName} at ${placement.companyName}`}
                  className="placement-image1"
                />
              )}
              <div className="placement-details1">
                <h3>{placement.studentName}</h3>
                <p>Company: {placement.companyName}</p>
                <p>Date: {new Date(placement.timestamp).toLocaleDateString()}</p>
                <button 
                  onClick={() => handleDelete(placement)}
                  className="delete-btn"
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ManagePlacement;